<div class="page-not-found">
    <h1>404</h1>
    <p>The page you're looking for doesn't exist.</p>
    <div *ngIf="marketId && marketId !=0">
        <a (click)="navigateHome()">Go back to Home</a>
    </div>
</div>